import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getHideColumnsList = createApi(`GetHideColumnsListSlice`,"GET");

const GetHideColumnsListSlice = createSlice({
  name: 'GetHideColumnsListSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getHideColumnsList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getHideColumnsList.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getHideColumnsList.rejected, (state, action) => {
        state.loading = false;
      })
  },
});

export default GetHideColumnsListSlice.reducer;